import { useEffect, useMemo, useState } from "react";
import { Seller } from "src/types/sellers";
import { axiosInstance, endpoints } from "src/utils/axios";
import {
  groupSellersByPosition,
  RankedPosition,
} from "../utils/ranking-helpers";

export function usePublicRanking() {
  const [sellers, setSellers] = useState<Seller[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPublicSellers = async () => {
      try {
        setLoading(true);
        // Marca a requisição como pública para evitar redirecionamento
        const response = await axiosInstance.get(endpoints.sellers.getAll, {
          params: { perPage: 1000 },
          _isPublicRequest: true,
        } as any);
        setSellers(response.data?.items || []);
      } catch (error) {
        console.error("Erro ao buscar sellers públicos:", error);
        setSellers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPublicSellers();
  }, []);

  const rankedSellers = useMemo(() => {
    // Filtrar apenas sellers ativos e ordenar por userCount (maior para menor)
    return sellers
      .filter((seller) => seller.status === "active")
      .sort((a, b) => (b.userCount || 0) - (a.userCount || 0));
  }, [sellers]);

  const rankedPositions = useMemo(() => {
    return groupSellersByPosition(rankedSellers);
  }, [rankedSellers]);

  return {
    rankedSellers,
    rankedPositions,
    loading,
  };
}
